import axios from 'axios';
import { DM_API_BASE } from './constants';

/**
 * Dedicated axios instance for the public Dailymotion Data API.
 *
 * Intentionally NOT the footmercato `rest` instance: no Bearer FM token and no
 * Hydra transform — this is an external, anonymous, public API. No secret is
 * involved (anonymous read is allowed and CORS is open).
 */
const restDailymotion = axios.create({
  baseURL: DM_API_BASE,
  validateStatus(status: number) {
    return status >= 200 && status < 300;
  },
});

export default restDailymotion;
